/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Donate_Co2_PlanInputs */

const en_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reduces ~${i?.number} kg of CO₂ yearly`)
};

const ar_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يقلل ~${i?.number} كجم من ثاني أكسيد الكربون سنويًا`)
};

const de_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reduziert jährlich ~${i?.number} kg CO₂`)
};

const es_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reduce ${i?.number} kg de CO₂ al año`)
};

const fr_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diminue les émissions de ~${i?.number} kg de CO₂ par an`)
};

const it_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riduce ~${i?.number} kg di CO₂ all'anno`)
};

const ja_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`年間約${i?.number}kgのCO₂を削減`)
};

const ko_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`매년 최대 ${i?.number}kg의 CO₂ 감축`)
};

const pt_br_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reduz ~${i?.number} kg de CO₂ por ano`)
};

const ru_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сокращает ~${i?.number} кг CO₂ ежегодно`)
};

const th_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ลดการปล่อย CO₂ ~${i?.number} กก. ต่อปี`)
};

const tr_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yıllık ~${i?.number} kg CO₂ azaltır`)
};

const zh_cn_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每年减少约 ${i?.number} 公斤二氧化碳`)
};

const zh_tw_earth_day_2025_donate_co2_plan = /** @type {(inputs: Earth_Day_2025_Donate_Co2_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每年減少約 ${i?.number} 公斤二氧化碳`)
};

/**
* | output |
* | --- |
* | "Reduces ~{number} kg of CO₂ yearly" |
*
* @param {Earth_Day_2025_Donate_Co2_PlanInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_donate_co2_plan = /** @type {((inputs: Earth_Day_2025_Donate_Co2_PlanInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Donate_Co2_PlanInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "ar") return ar_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "de") return de_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "es") return es_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "fr") return fr_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "it") return it_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "ja") return ja_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "ko") return ko_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "ru") return ru_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "th") return th_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "tr") return tr_earth_day_2025_donate_co2_plan(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_donate_co2_plan(inputs)
	return zh_tw_earth_day_2025_donate_co2_plan(inputs)
});